import { getIcon } from "../../../../../../../../../utils/get-icon";
import {
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  AccordionTitle,
  InnerAccordionHeader,
} from "../styled";
import { Textarea, TextareaWrapper } from "./styled";
import { useSettings } from "../../../../../context";

const ContentSettings = () => {
  const { updateContentSettings, getSelectedItemSettings } = useSettings();

  const currentSettings = getSelectedItemSettings();

  if (currentSettings?.type !== "text") {
    return null;
  }

  const handleContentChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newText = e.target.value;
    updateContentSettings({ text: newText });
  };

  return (
    <AccordionItem key="0" eventKey="0">
      <AccordionHeader>
        <InnerAccordionHeader>
          <AccordionTitle>{getIcon("")} Innhold</AccordionTitle>
        </InnerAccordionHeader>
      </AccordionHeader>
      <AccordionBody>
        <TextareaWrapper>
          <Textarea
            value={currentSettings.content.text}
            onChange={handleContentChange}
            placeholder="Skriv inn tekst"
            rows={3}
          >
            {currentSettings.content.text}
          </Textarea>
        </TextareaWrapper>
      </AccordionBody>
    </AccordionItem>
  );
};

export default ContentSettings;
